import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/Change/TaxAddress1.jpg'
import _imports_1 from '@/assets/imgs/Change/TaxAddress2.jpg'


const _withScopeId = n => (_pushScopeId("data-v-38502913"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-item" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "file-title" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 预览 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_9 = {
  key: 0,
  src: _imports_0
}
const _hoisted_10 = {
  key: 1,
  src: _imports_1
}

import { withDefaults, ref } from "vue";
import { FileType } from "../types/procss";
import axios from "axios";
import { previewFile } from "@/api/index";


export default /*#__PURE__*/_defineComponent({
  props: {
    title: { default: "" },
    filePath: { default: "" },
    fileType: { default: FileType.EXCEL },
    noDownload: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { title: string, filePath: string, fileType: FileType, noDownload: boolean }


const open = ref<boolean>(false);
const handlePreview = async () => {
  if (props.fileType == "png") {
    open.value = true;
    return;
  }
  // window.open(props.filePath);
  const Data = await previewFile(props.title || "");
  if (Data) {
    window.open(Data);
  }
};

const handleDownload = async (title: string) => {
  const filedata = await axios({
    method: "GET",
    url: `/api/template/manual/${title}`,
    responseType: "blob",
  });

  const blob = URL.createObjectURL(new Blob([filedata.data]));
  const el = document.createElement("a");
  el.setAttribute("download", title + "." + props.fileType);
  el.href = blob;
  document.body.appendChild(el);
  el.click();
  document.body.removeChild(el);
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.fileType == 'pdf')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: require('../assets/imgs/Common/pdf_2.png')
          }, null, 8, _hoisted_2))
        : (__props.fileType == 'doc' || __props.fileType == 'docx')
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: require('../assets/imgs/Common/word_2.png')
            }, null, 8, _hoisted_3))
          : (__props.fileType == 'excel')
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                src: require('../assets/imgs/Common/excel_2.png')
              }, null, 8, _hoisted_4))
            : (__props.fileType == 'png')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 3,
                  src: require('../assets/imgs/Common/png_1.png')
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_6, _toDisplayString(__props.title), 1),
      _createVNode(_component_a_button, {
        type: "link",
        style: {"padding-right":"0"},
        onClick: handlePreview
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      (!__props.noDownload)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 4,
            type: "link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleDownload(__props.title)))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_a_button, {
            key: 5,
            type: "link"
          }))
    ]),
    _createVNode(_component_a_modal, {
      visible: open.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((open).value = $event)),
      title: __props.title,
      width: "100%",
      "wrap-class-name": "full-modal",
      footer: null
    }, {
      default: _withCtx(() => [
        (__props.filePath == 'TaxAddress1')
          ? (_openBlock(), _createElementBlock("img", _hoisted_9))
          : _createCommentVNode("", true),
        (__props.filePath == 'TaxAddress2')
          ? (_openBlock(), _createElementBlock("img", _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})